export function canManageCustomerAccess(role: string | null | undefined): boolean {
  return role === 'admin' || role === 'superadmin';
}

export interface RevokeCustomerAccessInput {
  customer_user_id: string;
  expected_version: number;
  reason: string;
}

export async function revokeCustomerAccess(
  input: RevokeCustomerAccessInput,
  commit: (args: { p_customer_user_id: string; p_expected_version: number; p_reason: string }) => PromiseLike<{
    data: { id: string; status: string } | null;
    error: { message: string } | null;
  }>,
) {
  const reason = input.reason.trim();
  if (reason.length < 5 || reason.length > 1000) throw new Error('Enter a reason of 5 to 1000 characters');
  if (!Number.isSafeInteger(input.expected_version) || input.expected_version < 1) {
    throw new Error('Refresh the access record before revoking it');
  }
  const { data, error } = await commit({
    p_customer_user_id: input.customer_user_id,
    p_expected_version: input.expected_version,
    p_reason: reason,
  });
  if (error) throw new Error(error.message);
  if (data?.id !== input.customer_user_id || data.status !== 'revoked') {
    throw new Error('Revocation was not confirmed. Refresh the access record before trying again.');
  }
  return data;
}
